var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShow())?_c('a',{attrs:{"href":_vm.brandDetails.download.play,"target":"_blank"}},[_c('img',{staticClass:"track-click",class:{ 'va-base': _vm.brandDetails.mobileAppQr },attrs:{"src":require("@/assets/play-store.svg"),"alt":"appstore","width":_vm.width,"height":"auto"},on:{"click":_vm.trackAnchorClick}})]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }